<template>
  <div id="app">
    <div class="card border-primary" style="margin-bottom: 20px">
      <div class="card-header">
        <h5 style="margin-bottom: 0px">
          BetRadar Soccer Standings and Statistics
        </h5>
      </div>
      <div class="card-body">
        <div class="form-row">
          <div class="col">
            <div class="form-group">
              <label>Competition</label>
              <select @change="selectCompetition" class="form-control">
                <option value="">-- Select --</option>
                <option
                  v-for="competition in competitions"
                  :value="competition.id"
                  :key="competition.id"
                >
                  {{ competition.name }} - {{ competition.category.name }}
                </option>
              </select>
            </div>
          </div>

          <div class="col">
            <div class="form-group">
              <label>Season year</label>
              <select @change="selectSeasonYear" class="form-control">
                <option value="">-- Select --</option>
                <option
                  v-for="seasonYear in seasonYears"
                  :value="seasonYear.id"
                  :key="seasonYear.id"
                >
                  {{ seasonYear.year }}
                </option>
              </select>
            </div>
          </div>

          <div class="col">
            <div class="form-group" v-if="competitors">
              <label for="">Competitors</label>
              <select @change="selectCompetitor" class="form-control">
                <option value="">-- Select --</option>
                <option
                  v-for="team in competitors"
                  :value="team.id"
                  :key="team.id"
                >
                  {{ team.name }}
                </option>
              </select>
            </div>
          </div>
        </div>

        <div>
          <p>These are the BetRadar endpoints used to build this page.</p>
          <table class="table" style="text-align: left">
            <tr>
              <td>Competitions</td>
              <td>
                <a :href="getCompetitionEndpoint(true)" target="_blank">{{
                  getCompetitionEndpoint(true)
                }}</a>
              </td>
            </tr>
            <tr v-if="competitionId">
              <td>Competition Seasons</td>
              <td>
                <a :href="getCompetitionSeasonEndpoint(true)" target="_blank">{{
                  getCompetitionSeasonEndpoint(true)
                }}</a>
              </td>
            </tr>
            <tr v-if="seasonYearId">
              <td>Competitor Info</td>
              <td>
                <a :href="getCompetitorInfoEndpoint(true)" target="_blank">{{
                  getCompetitorInfoEndpoint(true)
                }}</a>
              </td>
            </tr>
            <tr v-if="seasonYearId">
              <td>Season Standings</td>
              <td>
                <a :href="getSeasonStandingsEndpoint(true)" target="_blank">{{
                  getSeasonStandingsEndpoint(true)
                }}</a>
              </td>
            </tr>
            <tr v-if="competitionId && competitorId">
              <td>Competitor Profile</td>
              <td>
                <a :href="getCompetitorProfileEndpoint(true)" target="_blank">{{
                  getCompetitorProfileEndpoint(true)
                }}</a>
              </td>
            </tr>
            <tr v-if="competitionId && competitorId">
              <td>Competitor Summaries</td>
              <td>
                <a :href="getCompetitorSummariesEndpoint(true)" target="_blank">{{
                  getCompetitorSummariesEndpoint(true)
                }}</a>
              </td>
            </tr>
            <tr v-if="competitionId && competitorId">
              <td>Seasonal Competitor Statistics</td>
              <td>
                <a :href="getCompetitorStatisticsEndpoint(true)" target="_blank">{{
                  getCompetitorStatisticsEndpoint(true)
                }}</a>
              </td>
            </tr>
            <tr v-if="playerId">
              <td>Player Profile</td>
              <td>
                <a :href="getPlayerProfileEndpoint(true)" target="_blank">{{
                  getPlayerProfileEndpoint(true)
                }}</a>
              </td>
            </tr>
            <tr v-if="playerId">
              <td>Player Summaries</td>
              <td>
                <a :href="getPlayerSummariesEndpoint(true)" target="_blank">{{
                  getPlayerSummariesEndpoint(true)
                }}</a>
              </td>
            </tr>
            <tr v-if="seasonYearId">
              <td>Season Leaders</td>
              <td>
                <a :href="getSeasonLeadersEndpoint(true)" target="_blank">{{
                  getSeasonLeadersEndpoint(true)
                }}</a>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>

    <div id="accordion">

      <div
        class="card"
        v-if="competitors"
      >
        <div class="card-header" id="headingOne">
          <h5 class="mb-0">
            <button
              class="btn btn-link"
              data-toggle="collapse"
              data-target="#collapseOne"
              aria-expanded="true"
              aria-controls="collapseOne"
            >
              Competition Competitors
            </button>
          </h5>
        </div>

        <div
          id="collapseOne"
          class="collapse show"
          aria-labelledby="headingOne"
        >
          <div class="card-body">
            <table class="table">
              <tr>
                <!-- <th>group</th> -->
                <th>id</th>
                <th>name</th>
                <th>abbreviation</th>
                <th>country</th>
                <th>country_code</th>
              </tr>
              
                <tr v-for="competitor in competitors" :key="competitor.id">
                  <!-- <td>{{ group.name ? group.name : "" }}</td> -->
                  <td>{{ competitor.id }}</td>
                  <td>{{ competitor.name }}</td>
                  <td>{{ competitor.abbreviation }}</td>
                  <td>{{ competitor.country }}</td>
                  <td>{{ competitor.country_code }}</td>
                </tr>
              
            </table>
          </div>
        </div>
      </div>

      <div
        class="card"
        v-if="competitorProfile"
      >
        <div class="card-header" id="headingTwo">
          <h5 class="mb-0">
            <button
              class="btn btn-link"
              data-toggle="collapse"
              data-target="#collapseTwo"
              aria-expanded="true"
              aria-controls="collapseTwo"
            >
              Competitor Profile
            </button>
          </h5>
        </div>

        <div
          id="collapseTwo"
          class="collapse show"
          aria-labelledby="headingTwo"
        >
          <div class="card-body">
            <table class="table">
              <tr>
                <th>Competitor info</th>
                <th>Category</th>
                <th>Manager</th>
                <th>Venue</th>
              </tr>
              <tr>
                <td v-if="competitorProfile.competitor">
                  id: {{ competitorProfile.competitor.id }} <br>
                  name: {{ competitorProfile.competitor.name }} <br>
                  country: {{ competitorProfile.competitor.country }} <br>
                  country_code: {{ competitorProfile.competitor.country_code }} <br>
                  abbreviation: {{ competitorProfile.competitor.abbreviation }} <br>
                  gender: {{ competitorProfile.competitor.gender }} <br>
                </td>
                <td v-if="competitorProfile.category">
                  id: {{ competitorProfile.category.id }} <br>
                  name: {{ competitorProfile.category.name }} <br>
                  country_code: {{ competitorProfile.category.country_code }} <br>
                </td>
                <td v-if="competitorProfile.manager">
                  id: {{ competitorProfile.manager.id }} <br>
                  name: {{ competitorProfile.manager.name }} <br>
                  date_of_birth: {{ competitorProfile.manager.date_of_birth }} <br>
                  nationality: {{ competitorProfile.manager.nationality }} <br>
                  country_code: {{ competitorProfile.manager.country_code }} <br>
                  gender: {{ competitorProfile.manager.gender }} <br>
                </td>
                <td v-if="competitorProfile.venue">
                  id: {{ competitorProfile.venue.id }} <br>
                  name: {{ competitorProfile.venue.name }} <br>
                  capacity: {{ competitorProfile.venue.capacity }} <br>
                  city_name: {{ competitorProfile.venue.city_name }} <br>
                  country_name: {{ competitorProfile.venue.country_name }} <br>
                  map_coordinates: {{ competitorProfile.venue.map_coordinates }} <br>
                  country_code: {{ competitorProfile.venue.country_code }} <br>
                </td>
              </tr>
              
            </table>

            <h3>Jerseys</h3>

              <table class="table" v-if=competitorProfile.jerseys>
                <tr>
                  <th>type</th>
                  <th>base</th>
                  <th>sleeve</th>
                  <th>number</th>
                  <th>squares</th>
                  <th>stripes</th>
                  <th>horizontal_stripes</th>
                  <th>split</th>
                  <th>shirt_type</th>
                  <th>sleeve_detail</th>
                </tr>
                <tr v-for="jersey in competitorProfile.jerseys" :key="jersey.id">
                  <td>{{ jersey.type }}</td>
                  <td>{{ jersey.base }}</td>
                  <td>{{ jersey.sleeve }}</td>
                  <td>{{ jersey.number }}</td>
                  <td>{{ jersey.squares }}</td>
                  <td>{{ jersey.stripes }}</td>
                  <td>{{ jersey.horizontal_stripes }}</td>
                  <td>{{ jersey.split }}</td>
                  <td>{{ jersey.shirt_type }}</td>
                  <td>{{ jersey.sleeve_detail }}</td>
                </tr>
              </table>
          </div>
        </div>
      </div>

      <div
        class="card"
        v-if="competitorSummaries"
      >
        <div class="card-header" id="headingSix">
          <h5 class="mb-0">
            <button
              class="btn btn-link"
              data-toggle="collapse"
              data-target="#collapseSix"
              aria-expanded="true"
              aria-controls="collapseSix"
            >
              Competitor Summaries
            </button>
          </h5>
        </div>

        <div
          id="collapseSix"
          class="collapse show"
          aria-labelledby="headingSix"
        >
          <div class="card-body">
            <table class="table">
              <tr>
                  <th>sport_event_time</th>
                  <th>ball_possession</th>
                  <th>cards_given</th>
                  <th>corner_kicks</th>
                  <th>fouls</th>
                  <th>free_kicks</th>
                  <th>goal_kicks</th>
                  <th>injuries</th>
                  <th>offsides</th>
                  <th>red_cards</th>
                  <th>shots_blocked</th>
                  <th>shots_off_target</th>
                  <th>shots_on_target</th>
                  <th>shots_saved</th>
                  <th>shots_total</th>
                  <th>substitutions</th>
                  <th>throw_ins</th>
                  <th>yellow_cards</th>
                  <th>yellow_red_cards</th>
                </tr>
                <tr v-for="summaries in competitorSummaries" :key="summaries.id">
                  <td>{{ summaries.eventTime }}</td>
                  <td>{{ summaries.competitorStatistics.ball_possession }}</td>
                  <td>{{ summaries.competitorStatistics.cards_given }}</td>
                  <td>{{ summaries.competitorStatistics.corner_kicks }}</td>
                  <td>{{ summaries.competitorStatistics.fouls }}</td>
                  <td>{{ summaries.competitorStatistics.free_kicks }}</td>
                  <td>{{ summaries.competitorStatistics.goal_kicks }}</td>
                  <td>{{ summaries.competitorStatistics.injuries }}</td>
                  <td>{{ summaries.competitorStatistics.offsides }}</td>
                  <td>{{ summaries.competitorStatistics.red_cards }}</td>
                  <td>{{ summaries.competitorStatistics.shots_blocked }}</td>
                  <td>{{ summaries.competitorStatistics.shots_off_target }}</td>
                  <td>{{ summaries.competitorStatistics.shots_on_target }}</td>
                  <td>{{ summaries.competitorStatistics.shots_saved }}</td>
                  <td>{{ summaries.competitorStatistics.shots_total }}</td>
                  <td>{{ summaries.competitorStatistics.substitutions }}</td>
                  <td>{{ summaries.competitorStatistics.throw_ins }}</td>
                  <td>{{ summaries.competitorStatistics.yellow_cards }}</td>
                  <td>{{ summaries.competitorStatistics.yellow_red_cards }}</td>
                </tr>
            </table>
          </div>
        </div>
      </div>

      <div
        class="card"
        v-if="competitorStatistics"
      >
        <div class="card-header" id="heading6">
          <h5 class="mb-0">
            <button
              class="btn btn-link"
              data-toggle="collapse"
              data-target="#collapse6"
              aria-expanded="true"
              aria-controls="collapse6"
            >
              Seasonal Competitor Statistics
            </button>
          </h5>
        </div>

        <div
          id="collapse6"
          class="collapse show"
          aria-labelledby="heading6"
        >
          <div class="card-body">
            <table class="table">
                <tr><th>average_ball_possession</th><td>{{ competitorStatistics.average_ball_possession }}</td></tr>
                <tr><th>cards_given</th><td>{{ competitorStatistics.cards_given }}</td></tr>
                <tr><th>corner_kicks</th><td>{{ competitorStatistics.corner_kicks }}</td></tr>
                <tr><th>free_kicks</th><td>{{ competitorStatistics.free_kicks }}</td></tr>
                <tr><th>goals_by_foot</th><td>{{ competitorStatistics.goals_by_foot }}</td></tr>
                <tr><th>goals_by_head</th><td>{{ competitorStatistics.goals_by_head }}</td></tr>
                <tr><th>goals_conceded</th><td>{{ competitorStatistics.goals_conceded }}</td></tr>
                <tr><th>goals_conceded_first_half</th><td>{{ competitorStatistics.goals_conceded_first_half }}</td></tr>
                <tr><th>goals_conceded_second_half</th><td>{{ competitorStatistics.goals_conceded_second_half }}</td></tr>
                <tr><th>goals_scored</th><td>{{ competitorStatistics.goals_scored }}</td></tr>
                <tr><th>goals_scored_first_half</th><td>{{ competitorStatistics.goals_scored_first_half }}</td></tr> 
                <tr><th>goals_scored_second_half</th><td>{{ competitorStatistics.goals_scored_second_half }}</td></tr>
                <tr><th>matches_played</th><td>{{ competitorStatistics.matches_played }}</td></tr>
                <tr><th>offsides</th><td>{{ competitorStatistics.offsides }}</td></tr>
                <tr><th>red_cards</th><td>{{ competitorStatistics.red_cards }}</td></tr>
                <tr><th>shots_blocked</th><td>{{ competitorStatistics.shots_blocked }}</td></tr>
                <tr><th>shots_off_target</th><td>{{ competitorStatistics.shots_off_target }}</td></tr>
                <tr><th>shots_on_bar</th><td>{{ competitorStatistics.shots_on_bar }}</td></tr>
                <tr><th>shots_on_post</th><td>{{ competitorStatistics.shots_on_post }}</td></tr>
                <tr><th>shots_on_target</th><td>{{ competitorStatistics.shots_on_target }}</td></tr>
                <tr><th>shots_total</th><td>{{ competitorStatistics.shots_total }}</td></tr>
                <tr><th>yellow_cards</th><td>{{ competitorStatistics.yellow_cards }}</td></tr>
                <tr><th>yellow_red_cards</th><td>{{ competitorStatistics.yellow_red_cards }}</td></tr>
            </table>
          </div>
        </div>
      </div>

 <div
        class="card"
        v-if="playersStatistics"
      >
        <div class="card-header" id="heading7">
          <h5 class="mb-0">
            <button
              class="btn btn-link"
              data-toggle="collapse"
              data-target="#collapse7"
              aria-expanded="true"
              aria-controls="collapse7"
            >
              Seasonal Players Statistics
            </button>
          </h5>
        </div>

        <div
          id="collapse7"
          class="collapse show"
          aria-labelledby="heading7"
        >
          <div class="card-body">
            <table class="table">
              <tr>
                  <th>Player</th>
                  <th>Id</th>
                  <th>Statistics</th>
                </tr>
                <tr v-for="player in playersStatistics" :key="player.id">
                  <td>{{ player.name }}</td>
                  <td>{{ player.id }}</td>
                  <td>
                        assists: {{ player.statistics.assists }}<br>
                        cards_given: {{ player.statistics.cards_given }}<br>
                        corner_kicks: {{ player.statistics.corner_kicks }}<br>
                        goals_by_head: {{ player.statistics.goals_by_head }}<br>
                        goals_by_penalty: {{ player.statistics.goals_by_penalty }}<br>
                        goals_scored: {{ player.statistics.goals_scored }}<br>
                        matches_played: {{ player.statistics.matches_played }}<br>
                        offsides: {{ player.statistics.offsides }}<br>
                        own_goals: {{ player.statistics.own_goals }}<br>
                        penalties_missed: {{ player.statistics.penalties_missed }}<br>
                        red_cards: {{ player.statistics.red_cards }}<br>
                        shots_blocked: {{ player.statistics.shots_blocked }}<br>
                        shots_off_target: {{ player.statistics.shots_off_target }}<br>
                        shots_on_targer: {{ player.statistics.shots_on_targer }}<br>
                        substituted_in: {{ player.statistics.substituted_in }}<br>
                        substituted_out: {{ player.statistics.substituted_out }}<br>
                        yellow_cards: {{ player.statistics.yellow_cards }}<br>
                        yellow_red_cards: {{ player.statistics.yellow_red_cards }}<br>
                    </td>
                </tr>
            </table>
          </div>
        </div>
      </div>

      <div
        class="card"
        v-if="players"
      >
        <div class="card-header" id="headingThree">
          <h5 class="mb-0">
            <button
              class="btn btn-link"
              data-toggle="collapse"
              data-target="#collapseThree"
              aria-expanded="true"
              aria-controls="collapseThree"
            >
              Players
            </button>
          </h5>
        </div>

        <div
          id="collapseThree"
          class="collapse show"
          aria-labelledby="headingThree"
        >
          <div class="card-body">
            <table class="table">
              <tr>
                <th>id</th>
                <th>name</th>
                <th>type</th>
                <th>date_of_birth</th>
                <th>nationality</th>
                <th>country_code</th>
                <th>height</th>
                <th>weight</th>
                <th>jersey_number</th>
                <th>preferred_foot</th>
                <th>place_of_birth</th>
                <th>gender</th>
              </tr>
              <tr v-for="player in players" :key="player.id">
                <td>{{ player.id }} </td>
                <td>{{ player.name }} </td>
                <td>{{ player.type }} </td>
                <td>{{ player.date_of_birth }} </td>
                <td>{{ player.nationality }} </td>
                <td>{{ player.country_code }} </td>
                <td>{{ player.height }} </td>
                <td>{{ player.weight }} </td>
                <td>{{ player.jersey_number }} </td>
                <td>{{ player.preferred_foot }} </td>
                <td>{{ player.place_of_birth }} </td>
                <td>{{ player.gender }} </td>
              </tr>
              
            </table>
          </div>
        </div>
      </div>

      <div 
        class="card"
        v-if="players"
      >
        <div class="card-header" id="headingFive">
          <h5 class="mb-0">
            <button
              class="btn btn-link"
              data-toggle="collapse"
              data-target="#collapseFive"
              aria-expanded="true"
              aria-controls="collapseFive"
            >
              Player 
            </button>
          </h5>
        </div>

        <div
          id="collapseFive"
          class="collapse show"
          aria-labelledby="headingFive"
        >
          <div class="card-body">
            <select class="form-control" @change="selectPlayer">
              <option value="">-- Select --</option>
              <option v-for="player in players" :value="player.id" :key="player.id">
                {{ player.name }}
              </option>
            </select>
            <br>
            <div v-if="playerProfile && playerSummaries">
              <table class="table">
                <tr>
                  <th>id</th>
                  <th>name</th>
                  <th>date_of_birth</th>
                  <th>gender</th>
                  <th>height</th>
                  <th>weight</th>
                  <th>nationality</th>
                  <th>preferred_foot</th>
                  <th>type</th>
                </tr>
                <tr>
                  <td>{{ playerProfile.player.id }}</td>
                  <td>{{ playerProfile.player.name }}</td>
                  <td>{{ playerProfile.player.date_of_birth }}</td>
                  <td>{{ playerProfile.player.gender }}</td>
                  <td>{{ playerProfile.player.height }}</td>
                  <td>{{ playerProfile.player.weight }}</td>
                  <td>{{ playerProfile.player.nationality }}</td>
                  <td>{{ playerProfile.player.preferred_foot }}</td>
                  <td>{{ playerProfile.player.type }}</td>
                </tr>
              </table>

              <h3 v-if="playerProfile.roles">Roles</h3>

              <table class="table" v-if="playerProfile.roles">
                <tr>
                  <th>start_date</th>
                  <th>end_date</th>
                  <th>team</th>
                  <th>active</th>
                  <th>jersey_number</th>
                  <th>type</th>
                </tr>
                <tr v-for="role in playerProfile.roles" :key="role.id">
                  <td>{{ role.start_date }}</td>
                  <td>{{ role.end_date }}</td>
                  <td>{{ role.competitor.name }}</td>
                  <td>{{ role.active }}</td>
                  <td>{{ role.jersey_number }}</td>
                  <td>{{ role.type }}</td>
                </tr>
              </table>

               <h3>Summaries</h3>

              <table class="table" v-if="playerSummaries">
                <tr>
                  <th>sport_event_time</th>
                  <th>assists</th>
                  <th>corner_kicks</th>
                  <th>goals_scored</th>
                  <th>offsides</th>
                  <th>own_goals</th>
                  <th>red_cards</th>
                  <th>shots_blocked</th>
                  <th>shots_off_target</th>
                  <th>shots_on_target</th>
                  <th>substituted_in</th>
                  <th>substituted_out</th>
                  <th>yellow_cards</th>
                  <th>yellow_red_cards</th>
                </tr>
                <tr v-for="summaries in playerSummaries" :key="summaries.id">
                  <td>{{ summaries.eventTime }}</td>
                  <template v-if="summaries.playerStatistics">
                    <td>{{ summaries.playerStatistics.statistics.assists }}</td>
                    <td>{{ summaries.playerStatistics.statistics.corner_kicks }}</td>
                    <td>{{ summaries.playerStatistics.statistics.goals_scored }}</td>
                    <td>{{ summaries.playerStatistics.statistics.offsides }}</td>
                    <td>{{ summaries.playerStatistics.statistics.own_goals }}</td>
                    <td>{{ summaries.playerStatistics.statistics.red_cards }}</td>
                    <td>{{ summaries.playerStatistics.statistics.shots_blocked }}</td>
                    <td>{{ summaries.playerStatistics.statistics.shots_off_target }}</td>
                    <td>{{ summaries.playerStatistics.statistics.shots_on_target }}</td>
                    <td>{{ summaries.playerStatistics.statistics.substituted_in }}</td>
                    <td>{{ summaries.playerStatistics.statistics.substituted_out }}</td>
                    <td>{{ summaries.playerStatistics.statistics.yellow_cards }}</td>
                    <td>{{ summaries.playerStatistics.statistics.yellow_red_cards }}</td>
                  </template>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </div>

      <div 
        class="card"
        v-if="standings"
      >
        <div class="card-header" id="headingFour">
          <h5 class="mb-0">
            <button
              class="btn btn-link"
              data-toggle="collapse"
              data-target="#collapseFour"
              aria-expanded="true"
              aria-controls="collapseFour"
            >
              Season Standings
            </button>
          </h5>
        </div>

        <div
          id="collapseFour"
          class="collapse show"
          aria-labelledby="headingFour"
        >
          <div class="card-body">
            <div v-for="standing in standings" :key="standing.id">
              <h3>{{ standing.type }}</h3>
              <p><b>tie_break_rule</b>: {{ standing.tie_break_rule }}</p>

              <table class="table" v-if="standing.groups">
                <tr>
                  <th>rank</th>
                  <th>team</th>
                  <th>played</th>
                  <th>points</th>
                  <th>win</th>
                  <th>loss</th>
                  <th>draw</th>
                  <th>played</th>
                  <th>goals_diff</th>
                  <th>goals_against</th>
                  <th>goals_for</th>
                  <th>change</th>
                  <th>current_outcome</th>
                  <th>points_per_game</th>
                  <th>form</th>
                </tr>
                <template v-for="group in standing.groups">
                  <tr v-for="groupStandings in group.standings" :key="groupStandings.id">
                    <td>{{ groupStandings.rank }}</td>
                    <td>{{ groupStandings.competitor.name }}</td>
                    <td>{{ groupStandings.played }}</td>
                    <td>{{ groupStandings.points }}</td>
                    <td>{{ groupStandings.win }}</td>
                    <td>{{ groupStandings.loss }}</td>
                    <td>{{ groupStandings.draw }}</td>
                    <td>{{ groupStandings.played }}</td>
                    <td>{{ groupStandings.goals_diff }}</td>
                    <td>{{ groupStandings.goals_against }}</td>
                    <td>{{ groupStandings.goals_for }}</td>
                    <td>{{ groupStandings.change }}</td>
                    <td>{{ groupStandings.current_outcome }}</td>
                    <td>{{ groupStandings.points_per_game }}</td>
                    <td>{{ groupStandings.competitor.form }}</td>
                  </tr>
                </template>
              </table>
            </div>
          </div>
        </div>
      </div>

      <div 
        class="card"
        v-if="seasonLeaders"
      >
        <div class="card-header" id="headingSeven">
          <h5 class="mb-0">
            <button
              class="btn btn-link"
              data-toggle="collapse"
              data-target="#collapseSeven"
              aria-expanded="true"
              aria-controls="collapseSeven"
            >
              Season Leaders
            </button>
          </h5>
        </div>

        <div
          id="collapseSeven"
          class="collapse show"
          aria-labelledby="headingSeven"
        >
          <div class="card-body">
            <div v-for="list in seasonLeaders" :key="list.id">
              <h3>by {{ list.type }}</h3>

              <table class="table">
                <tr>
                  <th>rank</th>
                  <th>player</th>
                  <th>competitor</th>
                  <th>data_point</th>
                </tr>
                <template v-for="leader in list.leaders">
                  <tr v-for="player in leader.players" :key="player.id">
                    <td>{{ leader.rank }}</td>
                    <td>
                      id: {{ player.name }}<br>
                      name: {{ player.name }}<br>
                    </td>
                    <td>
                      <div v-for="competitor in player.competitors" :key="competitor.id">
                        id: {{ competitor.id }}<br>
                        name: {{ competitor.name }}<br>
                        abbreviation: {{ competitor.abbreviation }}<br>
                      </div>
                    </td>
                    <td>
                      <div v-for="competitor in player.competitors" :key="competitor.id">
                        <div v-for="datapoint in competitor.datapoints" :key="datapoint.id">
                          type: {{ datapoint.type }} <br>
                          value: {{ datapoint.value }} <br>
                        </div>
                      </div>
                    </td>
                  </tr>
                </template>
              </table>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "app",
  components: {},
  data: function () {
    return {
      competitions: "",
      competitionId: "",
      seasonYears: "",
      seasonYearId: "",
      seasonLeaders: "",
      apiKey: "62xua64vk82qwkgzt8u2zrp6",
      standings: "",
      competitors: "",
      competitorId: "",
      competitorProfile: "",
      competitorSummaries: "",
      competitorStatistics: "",
      players: "",
      playerId: "",
      playerProfile: "",
      playerSummaries: ""
    };
  },
  created: async function () {
    try {
      const response = await axios.get(this.getCompetitionEndpoint(), {
        crossdomain: true,
      });
      this.competitions = response.data.competitions.sort(this.sortAlphabetically);
    } catch (err) {
      console.log('created: ',err);
    }
  },
  methods: {
    getCompetitionEndpoint: function (showBetradarUrl = false) {
      let url = `https://kaxmatrix.com/oddsapi/soccer/production/v4/en/competitions.json?api_key=${this.apiKey}`;

      if (showBetradarUrl) {
        url = url.replace(
          "https://kaxmatrix.com/oddsapi",
          "https://api.sportradar.us"
        );
      }

      return url;
    },

    getCompetitionSeasonEndpoint: function (showBetradarUrl = false) {
      let url = `https://kaxmatrix.com/oddsapi/soccer/production/v4/en/competitions/${this.competitionId}/seasons.json?api_key=${this.apiKey}`;

      if (showBetradarUrl) {
        url = url.replace(
          "https://kaxmatrix.com/oddsapi",
          "https://api.sportradar.us"
        );
      }

      return url;
    },

    getCompetitorInfoEndpoint: function (showBetradarUrl = false) {
      let url = `https://kaxmatrix.com/oddsapi/soccer/production/v4/en/seasons/${this.seasonYearId}/info.json?api_key=${this.apiKey}`;

      if (showBetradarUrl) {
        url = url.replace(
          "https://kaxmatrix.com/oddsapi",
          "https://api.sportradar.us"
        );
      }

      return url;
    },

    getSeasonStandingsEndpoint: function (showBetradarUrl = false) {
      let url = `https://kaxmatrix.com/oddsapi/soccer/production/v4/en/seasons/${this.seasonYearId}/standings.json?api_key=${this.apiKey}`;

      if (showBetradarUrl) {
        url = url.replace(
          "https://kaxmatrix.com/oddsapi",
          "https://api.sportradar.us"
        );
      }

      return url;
    },

    getCompetitorProfileEndpoint: function (showBetradarUrl = false) {
      let url = `https://kaxmatrix.com/oddsapi/soccer/production/v4/en/competitors/${this.competitorId}/profile.json?api_key=${this.apiKey}`;

      if (showBetradarUrl) {
        url = url.replace(
          "https://kaxmatrix.com/oddsapi",
          "https://api.sportradar.us"
        );
      }

      return url;
    },

    getCompetitorSummariesEndpoint: function (showBetradarUrl = false) {
      let url = `https://kaxmatrix.com/oddsapi/soccer/production/v4/en/competitors/${this.competitorId}/summaries.json?api_key=${this.apiKey}`;

      if (showBetradarUrl) {
        url = url.replace(
          "https://kaxmatrix.com/oddsapi",
          "https://api.sportradar.us"
        );
      }

      return url;
    },

    getPlayerProfileEndpoint: function (showBetradarUrl = false) {
      let url = `https://kaxmatrix.com/oddsapi/soccer/production/v4/en/players/${this.playerId}/profile.json?api_key=${this.apiKey}`;

      if (showBetradarUrl) {
        url = url.replace(
          "https://kaxmatrix.com/oddsapi",
          "https://api.sportradar.us"
        );
      }

      return url;
    },

    getPlayerSummariesEndpoint: function (showBetradarUrl = false) {
      let url = `https://kaxmatrix.com/oddsapi/soccer/production/v4/en/players/${this.playerId}/summaries.json?api_key=${this.apiKey}`;

      if (showBetradarUrl) {
        url = url.replace(
          "https://kaxmatrix.com/oddsapi",
          "https://api.sportradar.us"
        );
      }

      return url;
    },

    getSeasonLeadersEndpoint: function (showBetradarUrl = false) {
      let url = `https://kaxmatrix.com/oddsapi/soccer/production/v4/en/seasons/${this.seasonYearId}/leaders.json?api_key=${this.apiKey}`;

      if (showBetradarUrl) {
        url = url.replace(
          "https://kaxmatrix.com/oddsapi",
          "https://api.sportradar.us"
        );
      }

      return url;
    },

    getCompetitorStatisticsEndpoint: function (showBetradarUrl = false) {
      let url = `https://kaxmatrix.com/oddsapi/soccer/production/v4/en/seasons/${this.seasonYearId}/competitors/${this.competitorId}/statistics.json?api_key=${this.apiKey}`;

      if (showBetradarUrl) {
        url = url.replace(
          "https://kaxmatrix.com/oddsapi",
          "https://api.sportradar.us"
        );
      }

      return url;
    },

    loadCompetitionSeasons: async function () {
      if (this.competitionId == "") return;
      try {
        const response = await axios.get(this.getCompetitionSeasonEndpoint(), {
          crossdomain: true,
        });
        this.seasonYears = response.data.seasons.sort(this.sortAlphabetically);
       // this.seasonYearId = this.seasonYears[0].id;
        //this.loadCompetitiorsInfo();
      } catch (err) {
        console.log('loadCompetitionSeasons: ',err);
      }
    },

    loadCompetitiorsInfo: async function () {
      if (this.seasonYearId == "") return;
      try {
        const response = await axios.get(this.getCompetitorInfoEndpoint(), {
          crossdomain: true,
        });
        this.competitors = response.data.stages
          .map((stage) => {
            return stage.groups.map((group) => {
              return group.competitors.map((competitor) => {
                return competitor;
              });
            });
          })
          .flat(2)
          .filter(
            (competitor, index, self) =>
              index === self.findIndex((t) => t.id === competitor.id)
          )
          .sort(this.sortAlphabetically);
      } catch (err) {
        console.log('loadCompetitiorsInfo: ',err);
      }
    },

    loadSeasonStandings: async function() {
      if (this.seasonYearId == "") return;
      try {
        const response = await axios.get(this.getSeasonStandingsEndpoint(), {
          crossdomain: true,
        });
        this.standings = response.data.standings;
      } catch (err) {
        console.log('loadSeasonStandings: ',err);
      }
    },

    loadCompetitorStatistics: async function() {
      if (this.seasonYearId == "" && this.competitorId == "") return;
      try {
        const response = await axios.get(this.getCompetitorStatisticsEndpoint(), {
          crossdomain: true,
        });
        
        this.competitorStatistics = response.data.competitor.statistics;
        this.playersStatistics = response.data.competitor.players;
        
        // this.standings = response.data.standings;
      } catch (err) {
        console.log('loadSeasonStandings: ',err);
      }
    },

    loadCompetitorProfile: async function () {
      if (this.competitorId == "") return;
      try {
        const response = await axios.get(this.getCompetitorProfileEndpoint(), {
          crossdomain: true,
        });
        this.competitorProfile = response.data;
        this.players = response.data.players;
      } catch (err) {
        console.log('loadCompetitorProfile: ',err);
      }
    },

    loadCompetitorSumamries: async function () {
      if (this.competitorId == "") return;
      try {
        const response = await axios.get(this.getCompetitorSummariesEndpoint(), {
          crossdomain: true,
        });
        this.competitorSummaries = response.data.summaries.map(summary => {
          if(summary && summary.statistics){
            let competitorStatistics = summary.statistics.totals.competitors.find(competitor => competitor.id === this.competitorId);
            
            if(competitorStatistics && competitorStatistics.statistics){
              return {
                eventTime: summary.sport_event.start_time,
                competitorStatistics: competitorStatistics.statistics
              }
            }
          }
        }).filter(summary => summary != undefined);
      } catch (err) {
        console.log('loadCompetitorSumamries: ',err);
      }
    },

    loadPlayerProfile: async function () {
      if (this.playerId == "") return;
      try {
        const response = await axios.get(this.getPlayerProfileEndpoint(), {
          crossdomain: true,
        });
        this.playerProfile = response.data;
      } catch (err) {
        console.log('loadPlayerProfile: ',err);
      }
    },

    loadPlayerSummaries: async function () {
      if (this.playerId == "") return;
      try {
        const response = await axios.get(this.getPlayerSummariesEndpoint(), {
          crossdomain: true,
        });
        this.playerSummaries = response.data.summaries.map(summary => {
          if(summary && summary.statistics){
            let competitorStatistics = summary.statistics.totals.competitors.find(competitor => competitor.id === this.competitorId);

            if(competitorStatistics && competitorStatistics.players){
              return {
                eventTime: summary.sport_event.start_time,
                playerStatistics: competitorStatistics.players.find(playerStat => playerStat.id === this.playerId)
              }
            }
          }
        }).filter(summary => summary != undefined);
      } catch (err) {
        console.log('loadPlayerSummaries: ',err);
      }
    },

    loadSeasonLeaders: async function () {
      if (this.seasonYearId == "") return;
      try {
        const response = await axios.get(this.getSeasonLeadersEndpoint(), {
          crossdomain: true,
        });
        this.seasonLeaders = response.data.lists;
      } catch (err) {
        console.log('loadSeasonLeaders: ',err);
      }
    },

    selectCompetition: function (event) {
      this.competitionId = event.target.value;
      this.loadCompetitionSeasons();
    },

    selectCompetitor: function (event) {
      this.competitorId = event.target.value;
      this.loadCompetitorProfile();
      this.loadCompetitorSumamries();
      this.loadCompetitorStatistics();
    },

    selectSeasonYear: function (event) {
      this.seasonYearId = event.target.value;
      this.loadCompetitiorsInfo();
      this.loadSeasonStandings();
      this.loadSeasonLeaders();
    },

    selectPlayer: function (event) {
      this.playerId = event.target.value;
      this.loadPlayerProfile();
      this.loadPlayerSummaries();
    },
	
    sortAlphabetically: function (a, b) {
      let nameA = a.name.toUpperCase();
      let nameB = b.name.toUpperCase(); 
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }

      return 0;
    },
  },
  computed: {},
};
</script>
